module.exports = __webpack_public_path__ + "img/TechGatherWood3_ua.6280b5c4.webp";